/**
 * Collection description — Read more + place after Prefixbox grid/pagination.
 * Hidden until the product grid is ready so it never flashes under Sort/Show.
 */
(function () {
  const SECTION_SEL = '.collection-description-section';
  const WRAPPER_SEL = '.collection-description-wrapper';
  const PENDING_CLASS = 'collection-description-wrapper--pending';
  const READY_CLASS = 'collection-description-wrapper--ready';

  const getSection = () => document.querySelector(SECTION_SEL);

  const hideUntilReady = (wrapper) => {
    if (!wrapper) return;
    wrapper.classList.add(PENDING_CLASS);
    wrapper.classList.remove(READY_CLASS);
    wrapper.setAttribute('aria-hidden', 'true');
  };

  const revealReady = (wrapper) => {
    if (!wrapper) return;
    wrapper.classList.remove(PENDING_CLASS);
    wrapper.classList.add(READY_CLASS);
    wrapper.setAttribute('aria-hidden', 'false');
  };

  const backupHtml = () => {
    const section = getSection();
    const wrapper = section?.querySelector(WRAPPER_SEL);
    if (section && wrapper && !section.dataset.descBackup) {
      section.dataset.descBackup = wrapper.outerHTML;
    }
  };

  const getOrRestoreWrapper = () => {
    let wrapper = document.querySelector(WRAPPER_SEL);
    if (wrapper) return wrapper;

    const section = getSection();
    if (!section?.dataset.descBackup) return null;

    const tmp = document.createElement('div');
    tmp.innerHTML = section.dataset.descBackup;
    wrapper = tmp.firstElementChild;
    if (!wrapper) return null;

    const btn = wrapper.querySelector('#readMoreBtn');
    if (btn) delete btn.dataset.pfbxDescBound;
    hideUntilReady(wrapper);
    return wrapper;
  };

  /* Products must exist before we park the description under the grid */
  const isProductGridReady = (prefixboxMain) => {
    const results = prefixboxMain.querySelector('#results');
    if (!results) return false;
    return !!results.querySelector(
      '.prefixbox-product, .prefixbox-product-container, .tile-view .prefixbox-product, .tile-view > *'
    );
  };

  const placeDescriptionAfterGrid = () => {
    backupHtml();

    const wrapper = getOrRestoreWrapper() || document.querySelector(WRAPPER_SEL);
    if (wrapper) hideUntilReady(wrapper);

    const section = getSection();
    if (section) section.classList.add('collection-description-section--pending');

    const prefixboxMain = document.querySelector('#prefixbox-main');
    if (!prefixboxMain || !wrapper) return false;
    if (!isProductGridReady(prefixboxMain)) return false;

    const paginator = prefixboxMain.querySelector('#paginator');
    const results = prefixboxMain.querySelector('#results');
    const anchor = paginator || results;
    if (!anchor) return false;

    if (anchor.nextElementSibling !== wrapper) {
      anchor.insertAdjacentElement('afterend', wrapper);
    }

    if (section && !section.contains(wrapper)) {
      section.style.display = 'none';
      section.classList.remove('collection-description-section--pending');
    }

    revealReady(wrapper);
    return true;
  };

  const initReadMore = () => {
    const desc = document.getElementById('collectionDesc');
    const btn = document.getElementById('readMoreBtn');
    if (!desc || !btn || btn.dataset.pfbxDescBound === '1') return;

    /* Only measure when visible — otherwise scrollHeight is wrong */
    const wrapper = desc.closest(WRAPPER_SEL);
    if (!wrapper || wrapper.classList.contains(PENDING_CLASS)) return;

    const lineHeight = parseFloat(window.getComputedStyle(desc).lineHeight) || 22;
    const maxLines = 6;
    const maxHeight = lineHeight * maxLines;
    const fullHeight = desc.scrollHeight;

    if (fullHeight > maxHeight) {
      btn.style.display = 'inline-block';
      desc.style.maxHeight = maxHeight + 'px';
      btn.dataset.pfbxDescBound = '1';

      btn.addEventListener('click', function () {
        if (desc.style.maxHeight === maxHeight + 'px') {
          desc.style.maxHeight = fullHeight + 'px';
          btn.innerText = '<< Collapse';
        } else {
          desc.style.maxHeight = maxHeight + 'px';
          btn.innerText = 'Read More >>';
        }
      });
    }
  };

  const tick = () => {
    const placed = placeDescriptionAfterGrid();
    if (placed) initReadMore();
    return placed;
  };

  const boot = () => {
    const wrapper = document.querySelector(WRAPPER_SEL);
    if (wrapper) hideUntilReady(wrapper);
    tick();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  let tries = 0;
  const retry = setInterval(() => {
    tries += 1;
    if (tick() || tries > 60) clearInterval(retry);
  }, 200);

  const observeRoot = document.querySelector('#prefixbox-main') || document.body;
  let obsTimer = null;
  const observer = new MutationObserver(() => {
    clearTimeout(obsTimer);
    obsTimer = setTimeout(tick, 80);
  });
  observer.observe(observeRoot, { childList: true, subtree: true });
})();
